import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  var selectedCourse = localStorage.getItem('etlSelectCourse'); 
	var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));
  const [organisationName, setOrganisationName] = React.useState("");
  const [validityExpired, setValidityExpired] = React.useState(false);

  const [open, setOpen] = React.useState(false);
  const [sectionNoQuestionAttemptFlag, setSectionNoQuestionAttemptFlag] = React.useState(false);

  React.useEffect(() => {		
		if(open && props.testDetail){

      if(props.testDetail && props.testDetail.sectionSet && props.testDetail.sectionSet[0]){
        for(let i=0; i<props.testDetail.sectionSet.length; i++){
          if(props.testDetail.sectionSet[i].noQuestionAttempt>0){
            setSectionNoQuestionAttemptFlag(true);
            break;
          }
        }
      }

      setOrganisationName(mySelectedCourses[selectedCourse].organisationName);
      var d1 = new Date();
      var d2 = new Date(mySelectedCourses[selectedCourse].validTillDate);
      d2.setDate(d2.getDate() + 1);
      ////alert("Date>> "+d1.getFullYear()+"-"+d1.getMonth()+"-"+d1.getDate()); 
      // alert("packTypeTitle: "+mySelectedCourses[selectedCourse].packTypeTitle);
      ///alert("DATE: "+mySelectedCourses[selectedCourse].validTillDate);
      if(d1>d2 && mySelectedCourses[selectedCourse].packTypeTitle.indexOf("FREE")===-1 ){
        setValidityExpired(true);      
      }else{
        setValidityExpired(false);
      }      

		}
	}, [open,props.testDetail]); 

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function goToLocation(){ 
    setOpen(false);
    props.toCallStartTest();
	}

  function upgradeNow(){
    if(mySelectedCourses && selectedCourse>-1){
      window.location.href="selectcourse?cid="+mySelectedCourses[selectedCourse].courseId;
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>        
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{props.testDetail.testName}</h3></div>
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="5" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Total Questions</td>
                            <td style={{textAlign:'center'}} >{props.testDetail.totalQuestions}</td>                            
                        </tr>
                        {(props.testDetail.noQuestionAttempt && props.testDetail.noQuestionAttempt>0)?
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Max Questions Attempt</td>
                            <td style={{textAlign:'center'}} >{props.testDetail.noQuestionAttempt}</td>                            
                        </tr>
                        :null}
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Total time for Test(minute)</td>
                            <td style={{textAlign:'center'}} >{props.testDetail.testTotalTime}</td>
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Total Marks</td>
                            <td style={{textAlign:'center'}} >{props.testDetail.totalMarks}</td>
                        </tr>
                        {(props.testDetail && !props.testDetail.sectionSet)?
                        <>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                          <td>Correct Marks</td>
                          <td style={{textAlign:'center'}} >{props.testDetail.correctAnsMark}</td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                          <td>Wrong Marks</td>
                          <td style={{textAlign:'center'}} >{props.testDetail.wrongAnsMark}</td>
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                          <td>Not Answered Marks</td>
                          <td style={{textAlign:'center'}} >{props.testDetail.noAnsMark}</td>
                        </tr></>
                        :null}
                      </table>

                      {(props.testDetail && props.testDetail.sectionSet && props.testDetail.sectionSet[0])?
                      <table style={{backgroundColor:'#000000',width:'100%',marginTop:20 }} cellSpacing="1" cellPadding="5" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                          <th>Section</th>
                          <th>Question Range</th>
                          <th>Correct Marks</th>
                          <th>Incorrect Marks</th>
                          <th>Not Answered Marks</th>
                          {sectionNoQuestionAttemptFlag?<th>Max Questions Attempt</th>:null}
                          {(props.testDetail && props.testDetail.sectionSet && props.testDetail.sectionSet[0] && props.testDetail.sectionSet[0].totalTime)?<th>Total Time</th>:null}                          
                        </tr>                        
                        {props.testDetail.sectionSet?props.testDetail.sectionSet.map((myRow,index)=>(
                          <tr key={'mttr'+index} style={{backgroundColor:'#FFF'}} >
                            <td>{myRow.sectionName}</td>
                            <td style={{textAlign:'center'}} >{myRow.questionRange}</td>
                            <td style={{textAlign:'center'}} >{myRow.correctMarks}</td>
                            <td style={{textAlign:'center'}} >{myRow.incorrectMarks}</td>
                            <td style={{textAlign:'center'}} >{myRow.notAnswerMarks}</td>
                            {(sectionNoQuestionAttemptFlag>0)?<td style={{textAlign:'center'}} >{myRow.noQuestionAttempt>0?myRow.noQuestionAttempt:''}</td>:null}
                            {myRow.totalTime?<td style={{textAlign:'center'}} >{myRow.totalTime}</td>:null}
                          </tr>
                        )):<span>Records Not Available</span>}
                      </table>
                      :null}

                    {(validityExpired===true)?      
                     <Box mt={2} >
                      <h2 style={{textAlign:'center',color:'#FF0000',fontWeight:'bold'}}>
                        {(organisationName && organisationName.length>0)?<>{organisationName}'s</>:null} validity has been finished. Renew your account to continue your practice.
                        </h2> 
                     </Box>     
                    :null}

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:20,marginBottom:5}} size="small" variant="outlined" >Cancel</Button>
					    	      {(validityExpired===true)?
                        <Button title="Renew Now" variant="contained" onClick={() => {upgradeNow()}} size="small" style={{marginBottom:5,textTransform:'none',backgroundColor:'#008140',color:'#FFF'}} >Renew Now</Button>
                        :<Button onClick={() => {goToLocation()}} style={{marginBottom:5}} size="small" variant="contained" color="secondary" >Start Test</Button>
                      }
                      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
    </>
  );

});

export default CustomizedDialogs;